import * as React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



type Props = {
}
export const GotomypageButton: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
 const GotomypageButtonComponent = styled.button`
    box-sizing: border-box;
    width: 314px;
    height: 60px;
    background: linear-gradient(95.13deg, #D5B6ED -0.93%, #D5E0F7 41.61%, #D4AFEB 112.51%);
    border: 0.5px solid rgba(239, 239, 239, 0.2);
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.6);
    border-radius: 80px;
    transition: all 0.5s;
    background-image: url('https://nfttopshot-template.onrender.com/template-images/btn-rainbow-bg.png');
    color: rgba(213, 182, 237, 1);
    font-weight: 500;
    &::hover {
      opacity: 0.8;
    } 
 `;
 const nav = useNavigate();
  return (
    <GotomypageButtonComponent 
      // id="gotomypage" 
      id="btn-default-mypage-go" 
      type="button" 
      onClick={()=>nav('/4')}
    >
    {t('マイページへ移動')}
    </GotomypageButtonComponent>
  );
};